<template>
  <div ref="content" class="rich-content" v-html="html"></div>
</template>

<script>
import tippy from "tippy.js"
export default {
  name: "RichContentItem",
  props: {
    html: {
      required: true
    }
  },
  data() {
    return {
      tooltips: []
    }
  },
  methods: {
    wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el)
      wrapper.appendChild(el)
    }
  },
  mounted() {
    this.tooltips = tippy("span[data-emote]", {
      content: function(item) {
        return ":" + item.dataset.emote + ":"
      },
      duration: [400, 200],
      placement: "bottom",
      inertia: true
    })

    // let spoilers = this.$refs.content.querySelectorAll("span.spoiler img, span.spoiler div.noembed-iframe")

    // if (spoilers && spoilers.length) {
    //   spoilers.forEach(item => {
    //     let wrapper = document.createElement("div")
    //     wrapper.className = "spoiler-overlay"
    //     this.wrap(item, wrapper)
    //   })
    // }
  },
  beforeDestroy() {
    this.tooltips.forEach(function(tooltip) {
      tooltip.destroy(true)
    })
    this.tooltips = []
  }
}
</script>
